<ng-container *ngIf="groupedServiceCodes$ | async as serviceCodes">
  <div class="items-container flex flex-col gap-1">
    <div
      *ngFor="let serviceCode of serviceCodes; trackBy: trackByCode"
      class="flex flex-col gap-1"
    >
      <pr-service-item
        [serviceCode]="serviceCode"
        [compact]="compact"
        [disabled]="disabled"
        (itemUpdate)="itemUpdate(serviceCodes, serviceCode, $event)"
        (addServiceCode)="addServiceCode(serviceCodes, $event)"
      >
        <div class="action-container flex">
          <button
            *ngIf="!disabled"
            mat-icon-button
            class="icon-sm opacity-50"
            matTooltip="Reset to Fee Schedule price"
            tabindex="-1"
            [disabled]="serviceCode.priceOverride | map: resetPriceDisabled"
            (click)="resetPrice(serviceCodes, serviceCode)"
          >
            <mat-icon>restart_alt</mat-icon>
          </button>
          <button
            *ngIf="!disabled"
            class="delete icon-sm opacity-50"
            mat-icon-button
            color="warn"
            matTooltip="Delete Service Code"
            tabindex="-1"
            (click)="delete(serviceCodes, serviceCode)"
          >
            <mat-icon>clear</mat-icon>
          </button>
        </div>
      </pr-service-item>

      @if (serviceCode.pricingRule.type !== 'flat') {
        <div
          matTooltip="CON1 pricing is determined by the patient's school, and cannot be changed manually."
          [matTooltipDisabled]="!(serviceCode | map: isMohAnnualConsultation)"
        >
          <pr-service-pricing-rule-item-select
            [disabled]="
              disabled || (serviceCode | map: isMohAnnualConsultation)
            "
            [pricingRule]="serviceCode.pricingRule"
            (resetPrice)="resetPrice(serviceCodes, serviceCode)"
            (updateSelectedRuleItem)="
              updateSelectedRuleItem(serviceCodes, serviceCode, $event)
            "
          />
        </div>
      }
    </div>

    <pr-add-service-code-button
      *ngIf="!disabled && !searchDisabled"
      [connectedTo]="elementRef"
      [commonCodes]="commonCodes$ | async"
      [disabled]="disabled"
      (codeSelected)="addServiceCode(serviceCodes, $event)"
    />
  </div>
</ng-container>
